// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branding-section {
  margin-bottom: 40px;
}

.nav-section {
  margin-bottom: 60px;
}

.brand-desc {
  font-weight: 600;
  font-size: 30px;
  line-height: 120%;
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
  margin: 0;
  color: var(--color-card-text);
}

.error-border {
  border-color: var(--color-error);
}

.content {
  background-color: var(--color-card-background);
  padding: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: var(--color-card-text);
  margin: 10px 0px 10px 0px;
  text-align: center;
}

input {
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  color: #4f4f4f;
  height: 45px;
  border: 1px solid var(--color-secondary);
  border-radius: 2px;
}

.invalid {
  border-color: #d0011b;
}

.valid {
  border-color: var(--color-secondary);
  box-shadow: none;
}

.enter-text {
  margin-bottom: 1.5rem;
}

.noatum-info-box {
  position: relative;
  padding: 20px 40px 20px 20px;
  margin-bottom: 20px;
  background-color: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 6px;
  text-align: center;
}
.noatum-info-box .close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  color: #856404;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.noatum-info-box .close-btn:hover {
  opacity: 1;
}
.noatum-info-box .close-btn:focus {
  outline: none;
}
.noatum-info-box .icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
.noatum-info-box .icon-container .exclamation-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #ffc107;
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  border-radius: 50%;
  line-height: 1;
}
.noatum-info-box .info-text {
  margin: 0;
  color: #856404;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/retun-order-login/retun-order-login.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE,oCAAA;EACA,gBAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,kBAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAEF;AAAE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;AAEJ;AAAI;EACE,UAAA;AAEN;AACI;EACE,aAAA;AACN;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AADN;AAKE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAHJ","sourcesContent":[".branding-section {\n  margin-bottom: 40px;\n}\n\n.nav-section {\n  margin-bottom: 60px;\n}\n\n.brand-desc {\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 120%;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 0px;\n  margin: 0;\n  color: var(--color-card-text);\n}\n\n.error-border {\n  border-color: var(--color-error);\n}\n\n.content {\n  background-color: var(--color-card-background);\n  padding: 15px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  color: var(--color-card-text);\n  margin: 10px 0px 10px 0px;\n  text-align: center;\n}\n\ninput {\n  font-weight: 600;\n  font-size: 14px;\n  font-style: normal;\n  color: #4f4f4f;\n  height: 45px;\n  border: 1px solid var(--color-secondary);\n  border-radius: 2px;\n}\n\n.invalid {\n  border-color: #d0011b;\n}\n.valid {\n  border-color: var(--color-secondary);\n  box-shadow: none;\n}\n\n.enter-text {\n  margin-bottom: 1.5rem;\n}\n\n.noatum-info-box {\n  position: relative;\n  padding: 20px 40px 20px 20px;\n  margin-bottom: 20px;\n  background-color: #fff3cd;\n  border: 2px solid #ffc107;\n  border-radius: 6px;\n  text-align: center;\n\n  .close-btn {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1;\n    color: #856404;\n    cursor: pointer;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .icon-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 10px;\n\n    .exclamation-icon {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 40px;\n      height: 40px;\n      background-color: #ffc107;\n      color: #fff;\n      font-size: 28px;\n      font-weight: bold;\n      border-radius: 50%;\n      line-height: 1;\n    }\n  }\n\n  .info-text {\n    margin: 0;\n    color: #856404;\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
